var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryKm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9503)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9503",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9503)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H28V0H0V5.33333Z",
    fill: "#FFCB49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667H28V9.33337H0V14.6667Z",
    fill: "#DC1D34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V14.6666H0V20Z",
    fill: "#4985D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20L13.3333 10L0 0V20Z",
    fill: "#4BA343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 14C5.6788 14 6.01388 13.9562 6.3335 13.874C4.60827 13.4299 3.3335 11.8638 3.3335 10C3.3335 8.13616 4.60827 6.57006 6.3335 6.12602C6.01388 6.04375 5.6788 6 5.3335 6C3.12436 6 1.3335 7.79086 1.3335 10C1.3335 12.2091 3.12436 14 5.3335 14ZM8.00033 7.33335C8.00033 7.70154 7.70185 8.00002 7.33366 8.00002C6.96547 8.00002 6.66699 7.70154 6.66699 7.33335C6.66699 6.96516 6.96547 6.66669 7.33366 6.66669C7.70185 6.66669 8.00033 6.96516 8.00033 7.33335ZM7.33366 10.6666C7.70185 10.6666 8.00033 10.3682 8.00033 9.99998C8.00033 9.63179 7.70185 9.33331 7.33366 9.33331C6.96547 9.33331 6.66699 9.63179 6.66699 9.99998C6.66699 10.3682 6.96547 10.6666 7.33366 10.6666ZM8.00033 12.6667C8.00033 13.0349 7.70185 13.3333 7.33366 13.3333C6.96547 13.3333 6.66699 13.0349 6.66699 12.6667C6.66699 12.2985 6.96547 12 7.33366 12C7.70185 12 8.00033 12.2985 8.00033 12.6667Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9503"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryKm);
export default __webpack_public_path__ + "static/media/Country=KM.33ba21714a05980f473e8ed05ac202fa.svg";
export { ForwardRef as ReactComponent };